import HTTPRequest from '../index'

const apiPath = 'api/users'

class Reservation extends HTTPRequest {
  getVideoAppointment(token: string | undefined) {
    return this.get<Response.VideoAppointment>(
      `${apiPath}/reservations/video-appointment/${token}`,
    )
  }

  getAgoraToken() {
    return this.get<any>(`${apiPath}/agora-token?channel=doctor`)
  }

  endVideoCall(data: object) {
    return this.post<any>(`${apiPath}/end-call-video`, data)
  }
}

export default new Reservation()
